import View from './View';

export { default as View, getChromecastStopCastingStyles } from './View';

export default View;
